import { Component, OnChanges, Input } from '@angular/core';

import { Dimensions } from '../../models/dimensions.type';
import { Scale } from '../../models/scale.type';

@Component({
    selector: '[aaAxis]',
    templateUrl: './axis.component.html',
    styleUrls: [
        './axis.component.scss'
    ],
    standalone: false
})
export class AxisComponent implements OnChanges
{
    @Input() dimensions: Dimensions;
    @Input() orientation: 'x' | 'y' = 'x';
    @Input() scale: Scale;
    @Input() label: string;
    @Input() formatTick: (value: any) => (string);
    public ticks: number[] | Date[];

    ngOnChanges (): void
    {
        this.updateTicks();
    }

    updateTicks ()
    {
        if (!this.dimensions || !this.scale)
        {
            return;
        }

        const numberOfTicks = this.orientation === 'x'
            ? this.dimensions.boundedWidth < 600
                ? this.dimensions.boundedWidth / 100
                : this.dimensions.boundedWidth / 250
            : this.dimensions.boundedHeight / 50;

        this.ticks = this.scale.ticks(numberOfTicks);
        const spaces = [];
        for (let i = 0; i < this.ticks.length - 1; i++)
        {
            spaces.push(this.scale(this.ticks[i + 1]) - this.scale(this.ticks[i]));
        }
    }
}
